

<section id="footer">    
    <div class="container-fluid">
        <div class="row">
            <div class=" col-md-4 col-sm-6 col-12">
            <img src="assets/images/logo-white.png" class="img-fluid">
                <p class="about">
                    {{'landing.desc' | translate}}
                     </p>
                
              <!--   <p class="about">
                 لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمبورنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت انيم أد مينيم فينايم,كيواس نوستريدأكسير سيتاشن  لابورأس نيس
                </p> -->
                
            </div>
            <div class=" col-md-4 col-sm-6 col-12 one">
                <h3>{{'menu.contact' | translate}}    </h3>
                <ul class="footer-links">
                   <li>
                     <i class="ik ik-map-pin"></i>
                     <span class="address">
                        {{'landing.state' | translate}}  
                        {{'landing.address' | translate}}
                     </span>
                    </li>
                    
                    <li>
                      <i class="ik ik-calendar"></i>
                      {{'landing.workhours' | translate}} 
                      {{'landing.hours' | translate}}
                    </li>
                   
                </ul>
                
            </div>
         
            <div class=" col-md-4 col-sm-6 col-12 two">
                <h3>{{'landing.contactdet' | translate}}  </h3>
                <ul class="footer-links">
                    <li>
                        <i class="ik ik-smartphone"></i> <a  href="tel:00966112613500"> 00966112613500</a>
                    </li>
                    <li>
                        <i class="ik ik-mail"></i>  <a href="mailto:contact@seu.edu.sa"> contact@seu.edu.sa</a>
                    </li>
                    
                </ul>
            </div>
            
        </div>
        
        <div class="row sub-footer">
            <div class=" col-12">
                <span class="copyright">{{'landing.footer' | translate}}  
                </span>
            </div>
        </div>
        
</div>
</section>